/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { FilledButton, OutlinedButton, TextButton } from '@neo4j-ndl/react';

const Component = () => {
  return (
    <div className="n-grid n-grid-cols-3 n-gap-token-8 n-items-center">
      <FilledButton variant="primary">Filled Primary</FilledButton>
      <FilledButton variant="danger">Filled Danger</FilledButton>
      <div />
      <OutlinedButton variant="primary">Outlined Primary</OutlinedButton>
      <OutlinedButton variant="danger">Outlined Danger</OutlinedButton>
      <OutlinedButton variant="neutral">Outlined Neutral</OutlinedButton>
      <TextButton variant="primary">Text Primary</TextButton>
      <TextButton variant="danger">Text Danger</TextButton>
      <TextButton variant="neutral">Text Neutral</TextButton>
    </div>
  );
};

export default Component;
